<template>
  <div>
    <v-icon v-if="connected" class="mt-1 ml-1" color="success">mdi-ear-hearing</v-icon>
    <v-icon v-else class="mt-1 ml-1" color="error">mdi-ear-hearing-off</v-icon>
    <v-container class="llamadas-placeholder" v-if="estilo.type === 'LlamadasPlaceHolder'">
      <v-row no-gutters>
        <v-col lg="7">
          <v-list-item three-line>
            <v-list-item-content>
              <div
                class="display-2 font-weight-bold text-center header-call"
                :class="{'blink': calling}"
              >{{ lastCall }}</div>
              <v-divider></v-divider>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <div class="container" v-if="selectedMedia == 'images' && mediaContent != ''">
                <v-carousel
                  :show-arrows="false"
                  hide-delimiters
                  cycle
                  height="800px"
                  interval="10000"
                >
                  <v-carousel-item
                    v-for="(item,i) in mediaContent"
                    :key="i"
                    :src="`${apiUrl}/${item}`"
                    reverse-transition="fade-transition"
                    transition="fade-transition"
                  ></v-carousel-item>
                </v-carousel>
              </div>
              <div id="video-container" class="container" v-else-if="selectedMedia == 'youTubeUrl'">
                <vytia-player
                  v-if="mediaContent !== ''"
                  ref="yt"
                  :width="videoWidth"
                  :height="videoHeight"
                  :yturl="mediaContent"
                  @ended="youtubeVideoFinished"
                  @playing="youtubeVideoStarted"
                  :player-vars="{controls: 1, autoplay: 1}"
                ></vytia-player>
              </div>
              <div id="video-container" class="container" v-else-if="selectedMedia == 'video'">
                <video
                  v-if="mediaContent !== ''"
                  :src="`${apiUrl}/${mediaContent}`"
                  controls
                  loop
                  autoplay
                  muted
                  :style="{ width: videoWidth + 'px' , height: videoHeight + 'px' }"
                >Your browser does not support the video tag.</video>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col lg="5">
          <v-list-item three-line>
            <v-list-item-content>
              <div class="display-1 font-regular header-grid">Últimas llamadas</div>
              <v-divider></v-divider>
            </v-list-item-content>
          </v-list-item>
          <v-list-item three-line>
            <v-list-item-content>
              <v-card v-show="calling" class="center" outlined>
                <v-list-item three-line>
                  <v-list-item-content>
                    <div class="display-3 font-weight-bold text-center blink">{{ callingWho }}</div>
                    <v-divider class="my-5"></v-divider>
                    <div class="display-2 font-weight-bold text-center blink">{{ callingWhere }}</div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
              <v-simple-table v-show="!calling">
                <template v-slot:default>
                  <tbody>
                    <tr v-for="(item, index) in llamadasRecepcion" :key="index">
                      <td
                        class="who last-calls text-left"
                        :class="{'display-2':!item.showPatient, 'display-1':item.showPatient}"
                      >{{ item.quien }}</td>
                      <td class="where text-left display-2">{{ item.donde }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else class="llamadas-simple">
      <v-app>
        <v-card v-show="calling" class="center" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="display-10 font-weight-bold text-center blink">{{ callingWho }}</div>
              <v-divider class="my-5"></v-divider>
              <div class="display-8 font-regular text-center blink">{{ callingWhere }}</div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
        <v-simple-table v-show="!calling">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="who text-left">{{ getMessage('TTL_LLAMADAS_NUMERO') }}</th>
                <th class="where text-left">{{ getMessage('TTL_LLAMADAS_PUESTO') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in llamadasRecepcion" :key="index">
                <td class="who text-left">{{ item.quien }}</td>
                <td class="where text-left">{{ item.donde }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-app>
    </v-container>
  </div>
</template>
<script>
import { LogLevel, HubConnectionBuilder } from '@microsoft/signalr'
import { mapActions, mapState, mapGetters } from 'vuex'
import { Player } from 'vue-youtube-iframe-api'
import getAPIUrl from '@/helpers/getAPIUrl'

export default {
  computed: {
    ...mapState('Llamadas', ['llamadasRecepcion']),
    ...mapState('InitConfig', ['media']),
    ...mapGetters('GeneralAR', ['getMessage']),
    ...mapGetters('InitConfig', [
      'getEstilo',
      'getSalaActual',
      'getTipo',
      'getSelectedMedia'
    ]),
    connectionState: function () {
      if (this.connection !== null) {
        return this.connection.state
      }
      return ''
    },
    connected: function () {
      return this.isConnected()
    },
    tipoLlamador: function () {
      if (this.estilo.type === 'LlamadasPlaceHolder') {
        return 2
      } else {
        return 1
      }
    }
  },
  data () {
    return {
      connection: null,
      lastCall: '',
      calling: false,
      callingWho: '',
      callingWhere: '',
      salaActual: {},
      callingTime: 5000,
      tipo: {},
      estilo: {},
      selectedMedia: 0,
      apiUrl: '',
      audio: null,
      queue: [],
      mediaContent: '',
      youtubeWidth: 200,
      youtubeHeight: 200,
      icons: [
        'fab fa-facebook',
        'fab fa-twitter',
        'fab fa-linkedin',
        'fab fa-instagram'
      ]
    }
  },
  components: {
    'vytia-player': Player
  },
  destroyed () {
    this.connection.stop()
  },
  async mounted () {
    this.apiUrl = await getAPIUrl()
    this.salaActual = this.getSalaActual()
    this.estilo = this.getEstilo()
    this.tipo = this.getTipo()
    this.setMedia(this.estilo.type !== 'LlamadasPlaceHolder')
    this.fetchLlamadas()
    this.recursiveCall()
    await this.connectSignalR()
  },
  methods: {
    ...mapActions('Llamadas', ['fetchLlamadasRecepcion', 'fetchLlamadasConsultorio']),
    ...mapActions('InitConfig', ['fetchMedia']),
    joinSignalRGroup () {
      var vm = this
      vm.connection.invoke('AddToGroup', vm.salaActual.salaId.toString())
      vm.connection.on('Joined', msg => {})
    },
    fetchLlamadas () {
      var params = {
        salaId: this.salaActual.salaId,
        tipoLlamador: this.tipoLlamador
      }
      if (this.tipo.id === 1) {
        this.fetchLlamadasRecepcion(params)
      } else {
        this.fetchLlamadasConsultorio(params)
      }
    },
    listenSignalREvents () {
      var vm = this
      var signalREvent = this.tipo.id === 1 ? 'ReceiveNewLlamadaRecepcion' : 'ReceiveNewLlamadaConsultorio'
      vm.connection.on(signalREvent, data => {
        vm.queue.push(data)
        vm.fetchLlamadas()
      })
      vm.connection.on('RefreshScreen', data => {
        window.location.reload(true)
      })
    },
    async connectSignalR () {
      var vm = this
      vm.connection = new HubConnectionBuilder()
        .withUrl(`${vm.apiUrl}/llamadasHub`)
        .configureLogging(LogLevel.Debug)
        .withAutomaticReconnect([
          0,
          5000,
          10000,
          10000,
          10000,
          10000,
          10000,
          60000,
          null
        ])
        .build()
      vm.connection.start().then(function () {
        vm.joinSignalRGroup()
        vm.listenSignalREvents()
      })
      vm.connection.onreconnected(connectionId => {
        vm.joinSignalRGroup()
      })
    },
    isConnected () {
      return this.connectionState.toLowerCase().trim() === 'connected'
    },
    recursiveCall () {
      var vm = this
      setInterval(() => {
        var numberToCall = vm.queue.shift()
        if (typeof numberToCall !== 'undefined') {
          vm.call(numberToCall.quien, numberToCall.donde)
        }
      }, vm.callingTime + 500)
    },
    call (quien, donde) {
      var vm = this
      vm.lastCall = `${quien} ${vm.getMessage(
        'TXT_LLAMADAS_SEPARADOR_QUIEN_DONDE'
      )} ${donde}`
      vm.callingWho = quien
      vm.callingWhere = donde
      vm.calling = true
      setTimeout(() => {
        vm.calling = false
      }, vm.callingTime)
      vm.playSound()
      // setTimeout(() => {
      //   vm.llamadaPorAltaVoz(quien, donde)
      // }, 3000)
    },
    playSound () {
      this.audio.crossOrigin = 'anonymous'
      this.audio.play()
    },
    llamadaPorAltaVoz (quien, donde) {
      var msg = new SpeechSynthesisUtterance()
      msg.rate = 1
      msg.text = `${quien}, ..... ${donde}`
      window.speechSynthesis.speak(msg)
    },
    setMedia (onlyAudio) {
      var vm = this
      this.selectedMedia = this.getSelectedMedia()
      vm.fetchMedia().then(() => {
        vm.audio = new Audio(`${vm.apiUrl}/${vm.media.audio}`)
        if (!onlyAudio) {
          if (
            vm.selectedMedia === 'youTubeUrl' ||
            vm.selectedMedia === 'video'
          ) {
            vm.videoWidth =
              document.getElementById('video-container').offsetWidth < 200
                ? 200
                : document.getElementById('video-container').offsetWidth
            vm.videoHeight =
              document.getElementById('video-container').offsetHeight < 200
                ? 200
                : document.getElementById('video-container').offsetHeight
          }
          vm.mediaContent = vm.media[vm.selectedMedia]
        }
      })
    },
    youtubeVideoFinished () {
      this.$refs.yt.player.playVideo()
    },
    youtubeVideoStarted () {
      this.$refs.yt.player.mute()
    }
  }
}
</script>
<style lang="scss" scoped>
.llamadas-placeholder {
  tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, 0.05);
  }
  td.last-calls {
    height: 100px;
  }
  td.who {
    width: 65%;
  }
  td.where {
    width: 35%;
  }
  .container {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
  }
  .video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .header-call {
    height: 100px;
    padding-top: 30px;
  }
  .header-grid {
    height: 100px;
    padding-top: 60px;
  }
  .display-10 {
    font-size: 12px;
  }
  .display-8 {
    font-size: 10px;
  }
  .center {
    position: relative;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .blink {
    animation-name: parpadeo;
    animation-duration: 1s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;

    -webkit-animation-name: parpadeo;
    -webkit-animation-duration: 1s;
    -webkit-animation-timing-function: linear;
    -webkit-animation-iteration-count: infinite;
  }

  @-moz-keyframes parpadeo {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  @-webkit-keyframes parpadeo {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes parpadeo {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
}
.llamadas-simple {
  .display-10 {
    font-size: 120px;
  }
  .display-8 {
    font-size: 100px;
  }
  tbody {
    tr {
      height: 100px !important;
      td {
        font-size: 2vw !important;
      }
    }
    tr:nth-child(3) {
      height: 110px !important;
      td {
        font-size: 2.3vw !important;
        font-weight: bold;
      }
    }
    tr:nth-child(2) {
      height: 120px !important;
      td {
        font-size: 2.5vw !important;
        font-weight: bold;
      }
    }
    tr:first-child {
      height: 130px !important;
      td {
        font-size: 3vw !important;
        font-weight: bold;
      }
    }
  }
  thead {
    tr {
      height: 70px !important;
      th {
        font-size: 2vw !important;
      }
      th.who {
        width: 70%;
      }
      th.where {
        width: 30%;
      }
    }
  }
  .center {
    position: relative;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .blink {
    animation-name: parpadeo;
    animation-duration: 1s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;

    -webkit-animation-name: parpadeo;
    -webkit-animation-duration: 1s;
    -webkit-animation-timing-function: linear;
    -webkit-animation-iteration-count: infinite;
  }

  @-moz-keyframes parpadeo {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  @-webkit-keyframes parpadeo {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes parpadeo {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
}
</style>
